<template>
    <div class="organize-media-step">
        <div class="info">
            <p class="title">Organize your media</p>
            <p class="counter">
                {{
                    `${
                        userData.audios.length +
                        userData.videos.length +
                        userData.images.length
                    } files uploaded`
                }}
            </p>
            <p class="desc">You can organize them later on the profile settings page</p>
        </div>
        <div class="organizer">
            <MediaOrganizer
                :user-id="userData.id"
                :videos="userData.videos"
                :images="userData.images"
                :audios.sync="userData.audios"
                :profile-pic-indx.sync="profileIndx"
                @edit-photo="onEditImage"
            />
        </div>
    </div>
</template>
<script>
    import MediaOrganizer from './parts/MediaOrganizer'

    export default {
        name: 'OrganizeMedia',
        props: {
            userData: {
                type: Object,
                required: true
            },
            profilePicIndx: {
                type: Number,
                required: true
            }
        },
        components: {
            MediaOrganizer
        },
        data: (self) => ({
            profileIndx: self.profilePicIndx
        }),
        watch: {
            profileIndx: {
                handler: function (val) {
                    this.$emit('update:profile-pic-indx', val)
                },
                immediate: true
            }
        },
        methods: {
            onEditImage(image) {
                console.log('onEditImage', image)
                this.$emit('edit-photo', image)
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .organize-media-step {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 24px;

        .info {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            gap: 8px;

            .title {
                color: #dedede;
                @include base-font-24;
                font-weight: 600;
                line-height: 28px;
            }
            .counter {
                color: #dedede;
                @include base-font-16;
                font-weight: 400;
                line-height: 24px;
            }
            .desc {
                color: #8b8b8b;
                @include base-font-16;
                font-weight: 400;
                line-height: 24px;
            }
        }
        .organizer {
            width: 100%;
        }
    }
</style>
